const actions = {
    SET_DATE: 'SET_DATE',
    SET_PART: 'SET_PART',
    SET_EXERCISE: 'SET_EXERCISE',
    SET_TYPE: 'SET_TYPE'
}

export default actions